<template>
  <div>
    <div class="flex flex-row flex-no-wrap mx-3 mt-3 text-xs">
      <span class="text-gray mr-3">排序</span>
      <div class="flex flex-grow justify-start">
        <div
          v-for="item in [
            { name: '上新', code: 'upNew' },
            { name: '销量', code: 'salesNum' },
            { name: '转发次数', code: 'forwardNum' },
          ]"
          :key="item.code"
          style="
            display: inline-block;
            box-sizing: border-box;
            min-width: 20%;
            max-width: 25%;
          "
          :class="{ sortColumn: sortColumn === item.code }"
          @click="changeSort(item.code)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <List
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getBrandPlace"
      v-if="activeTab === 'home'"
    >
      <!-- //这里改动 -->
      <!-- //主体数据 -->

      <BrandPlaceCard
        v-for="item in list"
        :key="item.partId"
        :goodsList="item.brandGoodsList"
        :id="item.partId"
        :actId="item.actId"
        :tags="item.partServices"
        :brandName="item.brandName"
        :brandLogo="item.brandLogo"
        :start="item.start"
        :end="item.end"
        :state="item.state"
        :signBrandId="item.signBrandId"
        :partId="item.partId"
      />
    </List>
    <!-- //客户（小c)卡片的是这个结构 -->
    <div
      v-else-if="
        activeTab !== 'home' && $store.state.user.distributionFlag === false
      "
    >
      <GoodsList
        oneTabBrand="oneTabBrand"
        :activeTab="activeTab"
        :sortColumn="sortColumn"
      />
    </div>

    <!-- //分销（小b)列表的是这个结构 -->
    <div
      v-else-if="
        activeTab !== 'home' && $store.state.user.distributionFlag === true
      "
    >
      <GoodsList
        oneTabBrand="oneTabBrand"
        :activeTab="activeTab"
        :sortColumn="sortColumn"
      />
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import BrandPlaceCard from './components/BrandPlaceCard'
import { getBrandPlaceList } from './webApi'
import GoodsList from '@/views/BrandPlace/components/GoodsList'
export default {
  name: 'BrandPlaceList',
  components: { BrandPlaceCard, List, GoodsList },
  props: ['activeTab', 'scrollTop'],
  data() {
    return {
      page: 0,
      size: 10,
      list: [],
      loading: false,
      finished: false,
      sortColumn: 'upNew',
      target: 0,
    }
  },
  methods: {
    changeSort(code) {

      this.sortColumn = code
      this.$store.commit('user/SET_scrollTop', this.scrollTop)
      this.$emit('setScrollTop', this.$store.state.user.scrollTop)
    },
    getBrandPlace(
      params = {
        page: this.page,
        size: this.size,
        platformCateId: this.activeTab === 'home' ? null : this.activeTab,
        sortColumn: this.sortColumn,
        sortRole: 'DESC',
      }
    ) {

      getBrandPlaceList(params).then((res) => {

        this.list = this.list.concat(res.data.content)
        //后端改成不分页了

        this.loading = false
        this.page++
        if (this.list.length >= res.data.totalElements) {
          this.finished = true
        }
      })
    },

    //其他tab项 客户端（小b) 卡片瀑布流获得的数据
    //接口参数根据张宇
    // getOneTabBrandGoods(
    //   params = {
    //     page: this.page,
    //     size: this.size,
    //     platformCateId: this.activeTab,
    //   }
    // ) {
    //
    //   getOneTabBrandGoods(params).then((res) => {
    //
    //     this.list = this.list.concat(res.data.content)
    //     //后端改成不分页了
    //     // this.list = res.data;
    //     this.loading = false
    //     this.page++
    //     if (this.list.length >= res.data.totalElements) {
    //       this.finished = true
    //     }
    //   })
    // },
  },
  watch: {
    activeTab(val) {

      if (val !== 'home') {
        return false
      }
      console.log('下')
      this.page = 0
      this.list = []
      this.loading = true
      this.finished = false
      if (this.loading) {

        this.getBrandPlace()
      }
    },
    sortColumn(val) {
      this.page = 0
      this.list = []
      this.finished = false
    },
  },
}
</script>

<style scoped>
.sortColumn {
  color: #e82035;
  font-weight: 600;
}
</style>
